import { PaycheckRoutingStatus } from '@fruitful/income-split';
import { router } from 'expo-router';
import * as React from 'react';
import {
    BodySmallEmphasized,
    Icon,
    Row,
    RowList,
    SplitIcon,
    View,
} from 'smoothie';

import { useRoadmapTabExperience } from '../../../roadmap/hooks/useRoadmapTabExperience';

export const IncomeSplitCard = ({
    status,
}: {
    status?: PaycheckRoutingStatus;
}) => {
    const tabExperience = useRoadmapTabExperience();

    const badgeColor =
        status === PaycheckRoutingStatus.ACTIVE ? '$green800' : '$gray400';
    const badgeTextColor =
        status === PaycheckRoutingStatus.ACTIVE ? '$white' : '$black';
    const badgeText = status === PaycheckRoutingStatus.ACTIVE ? 'ON' : 'OFF';

    return (
        <RowList>
            <Row
                title="Income Split"
                subtitle="Deposits into this account will follow your Income Split rules"
                onPress={() => {
                    router.navigate(
                        tabExperience === 'money_system'
                            ? '/home/roadmap'
                            : '/income-split',
                    );
                }}
                leftContentOverride={
                    <View rotate="180deg">
                        <Icon icon={SplitIcon} size={18} color="$black" />
                    </View>
                }
                rightContent={
                    <View
                        backgroundColor={badgeColor}
                        borderRadius={16}
                        paddingHorizontal={12}
                        paddingVertical={4}
                    >
                        <BodySmallEmphasized color={badgeTextColor}>
                            {badgeText}
                        </BodySmallEmphasized>
                    </View>
                }
            />
        </RowList>
    );
};
